import React, { Component } from 'react';
import './DrugAdministrationCard.css';
import Chart from 'chart.js';
import models from '../../model/models';
import Card from '../card/Card';
import Label from '../label/Label';
import utils from '../../utils/utils';
import mainAPI from '../../api/MainAPI';
import cloneDeep from 'lodash.clonedeep';
import FilterInput from '../../inputs/filterInput/FilterInput';
import Toggle from '../../inputs/toggle/Toggle';
import { getDisplayUnit } from '../../utils/gramUtils';
import Volume from '../volume/Volume';

let nintyDaysAgo = utils.xDaysAgo(90);
export default class DrugAdministrationCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fromDate: nintyDaysAgo,
			toDate: new Date(),
			users: models.user.objs(),
			graphData: '',
			dataSets: [],
			toggleValue: 1
		};
	}

	componentDidMount = async () => {
		this.subscribeId = models.user.onCurrentChange(this._setUser);
		let drug_types = await mainAPI.drug_type.allowed_drugs();
		this.setState({ drug_types });
	};

	componentWillUnmount = () => {
		models.user.unsubscribe(this.subscribeId);
	};

	_setUser = (user) => {
		if (!user) return;
		this.setState({ user }, () => {
			this._handleFilterChange({
				created_on: { values: [this._defaultFilter()[0].value, this._defaultFilter()[1].value] },
				created_by_id: { values: [this._defaultFilter()[2].value] }
			});
		});
	};

	_groupDataByUser = async () => {
		let data = cloneDeep(this.state.graphData);
		let rawData = {};
		for (let i in data) {
			let rawSMR = data[i];
			let userId = rawSMR.user_id;
			if (rawData[userId]) {
				rawData[userId].push(rawSMR);
			} else if (!rawData[userId]) {
				rawData[userId] = [rawSMR];
			}
		}
		let allDataPoints = [];
		for (let i in rawData) {
			let dataPoints = await this._graphData(rawData[i]);
			allDataPoints.push(dataPoints);
		}
		return allDataPoints;
	};

	_graphData = async (data) => {
		let graphData = data;
		let graphDataSMR = [];
		for (let i = 0; i < graphData.length; i++) {
			let created_on = graphData[i].created_on;
			let dateSimple = toSimpleDate(created_on);
			let graphDataNew = { ...graphData[i], dateSimple: dateSimple };
			graphDataSMR.push(graphDataNew);
		}
		let formattedStockMoveRecords = this._formatData(graphDataSMR);
		let dataPoints = this._createDataPoints(formattedStockMoveRecords);
		return dataPoints;
	};

	_formatData = (graphDataSMR) => {
		let formattedSMR = this._groupDataByDate(graphDataSMR);
		let SMRWithEmptyDays = this._addZeroForEmptyDays(formattedSMR);
		let finalFormattedSMR = this._dateSortOrder(SMRWithEmptyDays);

		return finalFormattedSMR;
	};

	_groupDataByDate = (data) => {
		let rawData = {};
		for (let i in data) {
			let rawSMR = data[i];
			let date = rawSMR.dateSimple;
			if (rawData[date]) {
				rawData[date].push(rawSMR);
			} else if (!rawData[date]) {
				rawData[date] = [rawSMR];
			}
		}
		return rawData;
	};

	_addZeroForEmptyDays = (graphDataSMR) => {
		if (!this.state.fromDate) return graphDataSMR;
		if (!this.state.toDate) return graphDataSMR;
		let start = cloneDeep(this.state.fromDate);
		for (let i = start; i.getTime() <= this.state.toDate.getTime(); i.setDate(i.getDate() + 1)) {
			let dateSimple = toSimpleDate(i);
			if (!graphDataSMR[dateSimple]) graphDataSMR[dateSimple] = [];
			Object.defineProperty(graphDataSMR[dateSimple], 'time', { enumerable: false, writable: true });
			graphDataSMR[dateSimple].time = toSimpleDate(i);
		}
		let graphDataSMRWithZero = graphDataSMR;
		return graphDataSMRWithZero;
	};

	_dateSortOrder = (data) => {
		let datesAccepted = [];
		for (let i in data) {
			let SMR = data[i];
			if (!SMR.time) continue;
			datesAccepted.push(SMR);
		}
		datesAccepted = datesAccepted.sort(this._orderByDate);
		return datesAccepted;
	};

	_orderByDate = (a, b) => {
		if (new Date(a.time) < new Date(b.time)) return -1;
		if (new Date(a.time) > new Date(b.time)) return 1;
		return 0;
	};

	_volumeOrVial = (SMR) => {
		let toggleValue = this.state.toggleValue;
		if (toggleValue === 1) {
			return SMR.length;
		} else if (toggleValue === 2) {
			let quantity = 0;
			for (let i in SMR) {
				let oneStockMoveRecord = SMR[i];
				if (!oneStockMoveRecord.quantity) {
					continue;
				}
				quantity += Math.abs(oneStockMoveRecord.quantity);
			}
			return quantity;
		}
	};

	_createDataPoints = (formattedStockMoveRecords) => {
		let dataPoints = [];
		for (let i in formattedStockMoveRecords) {
			let SMR = formattedStockMoveRecords[i];
			let date = utils.display_actual_date(new Date(SMR.time));
			let dataPoint = { y: this._volumeOrVial(SMR), x: date, toolTipLabels: [], user: '' };

			for (let j in SMR) {
				let SMRtoolTipLabels = [];
				let stockMove = SMR[j];
				let user = stockMove.user_name;
				let drugTypeId = stockMove.type;
				let drugType = models.drug_type.obj(drugTypeId);
				let drugTypeName = drugType.name;
				let unitOfMeasure = getDisplayUnit(drugTypeId);
				const usageType = this._getUsageType(stockMove.stock_move_type_id);
				if(!usageType){
					console.warn('unknown stockMovement', stockMove);
					continue;
				}
				let action = usageType.toLowerCase();
				let id = stockMove.drug__barcode_id;
				let quantity = Math.abs(stockMove.quantity);
				if (!quantity) quantity = 0;
				let amount = Volume.inPreferredUnit(quantity, drugTypeId);

				let toolTipLabel = `${user} ${action} ${amount} ${unitOfMeasure} of ${drugTypeName} (${id})`;

				SMRtoolTipLabels.push(toolTipLabel);
				dataPoint.toolTipLabels.push(SMRtoolTipLabels);
				dataPoint.user = stockMove.user_name;
			}
			dataPoints.push(dataPoint);
		}
		return dataPoints;
	};

	_findLabel = (data) => {
		let label = '';
		for (let i in data) {
			let dataPoint = data[i];
			if (dataPoint.user !== '') {
				label = dataPoint.user;
			}
		}
		return label;
	};

	_createDataSets = (data) => {
		let dataSets = [];
		let colors = ['#2677D3', '#ed8961', '#69c09e', '#c75450', '#5d6b81', '#30fdf1'];
		for (let i in data) {
			let dataPoints = data[i];
			let label = this._findLabel(data[i]);
			let dataSet = {
				data: dataPoints,
				label: label,
				borderColor: colors[i],
				pointStyle: 'circle',
				pointHitRadius: '5',
				radius: '5',
				fill: false
			};
			dataSets.push(dataSet);
		}
		return dataSets;
	};

	_equalDataSets(dataSet, otherDataSet) {
		if (dataSet.length !== otherDataSet.length) return false;
		for (let i in dataSet) {
			const {data, label} = dataSet[i];
			const {data: otherData, label: otherLabel} = otherDataSet[i];
			if (label !== otherLabel) return false;
			if (data.length !== otherData.length) return false;
			for (let j in data) {
				const {x, y} = data[j];
				const {x: otherX, y: otherY} = otherData[j];
				if (x !== otherX) return false;
				if (y !== otherY) return false;
			}
		}
		return true;
	}

	_createChart = async () => {
		let graphData = (await this._groupDataByUser()) || {};
		if (!graphData) return;
		let dataSets = this._createDataSets(graphData);
		// If the data is exactly the same, don't update the chart
		if (this._equalDataSets(dataSets, this.state.dataSets)) return;
		this.setState({ dataSets });
		if (!document.getElementById('drug-administration-chart')) return;
		const ctx = document.getElementById('drug-administration-chart').getContext('2d');
		if (window.bar != undefined) {
			window.bar.destroy();
		}
		window.bar = new Chart(ctx, {
			type: 'line',
			data: {
				datasets: dataSets
			},
			options: {
				title: {
					display: false,
					text: 'Quantity'
				},
				maintainAspectRatio: false,
				responsive: true,
				legend: { labels: { usePointStyle: true } },
				tooltips: {
					callbacks: {
						label: function(tooltipItem, data) {
							if (!data.datasets[tooltipItem.datasetIndex]) return '';
							let toolTipLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toolTipLabels;
							return toolTipLabel;
						}
					}
				},
				scales: {
					yAxes: [
						{
							ticks: {
								min: 0
							}
						}
					],
					xAxes: [
						{
							type: 'time',
							time: { unit: 'day' }
						}
					]
				}
			}
		});
	};

	_handleFilterChange = async (filter) => {
		let graphData = await mainAPI.stock_move_record.filter(filter);
		let fromDate = this._getFromDate(graphData);
		let toDate = this._getToDate(graphData);
		this.setState({ graphData: graphData, fromDate, toDate });
	};

	_getFromDate = (graphData) => {
		let startDate = Date.now();
		for (let i in graphData) {
			if (!graphData[i] || !graphData[i].created_on) continue;
			if (startDate > graphData[i].created_on.getTime()) {
				startDate = graphData[i].created_on.getTime();
			}
		}
		return new Date(startDate);
	};

	_getToDate = (graphData) => {
		let endDate = 0;
		for (let i in graphData) {
			if (!graphData[i] || !graphData[i].created_on) continue;
			if (endDate < graphData[i].created_on.getTime()) {
				endDate = graphData[i].created_on.getTime();
			}
		}
		const oneDayInMilliseconds = 1000 * 60 * 60 * 24;
		return new Date(endDate + oneDayInMilliseconds);
	};

	_defaultFilter = () => {
		let filter = [
			{
				value: { datetime: utils.client_to_server_datetime(this.state.fromDate), operator: '>' },
				name: utils.display_actual_datetime(this.state.fromDate),
				column: 'created_on',
				displayName: 'Start'
			},
			{
				value: { datetime: utils.client_to_server_datetime(this.state.toDate), operator: '<' },
				name: utils.display_actual_datetime(this.state.toDate),
				column: 'created_on',
				displayName: 'End'
			}
		];
		let user = models.user.obj(this.props.userId) || this.state.user;
		let name = user.first_name + ' ' + user.last_name;
		let id = user.id;
		let nameFilter = { value: id, name: name, column: 'created_by_id', displayName: 'User' };
		if (this.state.user) {
			filter.push(nameFilter);
		}
		return filter;
	};

	_renderFilter = () => {
		if (!this.state.user) return null;
		return (
			<FilterInput
				currentFilter={this._defaultFilter()}
				onChange={this._handleFilterChange}
				options={[
					{
						column: 'created_by_id',
						model: 'user',
						displayName: 'User',
						filterColumns: ['first_name', 'last_name'],
						idColumn: 'id'
					},
					{ column: 'type', displayName: 'Drug Type', options: this.state.drug_types },
					{
						column: 'stock_move_type_id',
						displayName: 'Usage Type',
						options: {
							waste: { name: 'Waste', value: 1 },
							administer: { name: 'Administer', value: 2 },
							take_ownership: { name: 'Created', value: 3 },
							un_administer: { name: 'Un-Administer', value: 4 },
							adjustment: { name: 'Adjustment', value: 5 }
						}
					},
					{ column: 'unit_id', model: 'unit', displayName: 'Unit', filterColumns: ['name'], idColumn: 'id' },
					{
						column: 'drug_box_id',
						model: 'drug_box',
						displayName: 'Drug Box',
						filterColumns: ['name', 'barcode_id'],
						idColumn: 'id'
					},
					{ column: 'created_on', displayName: 'Date', type: 'datetime' }
				]}
			/>
		);
	};

	_getUsageType = (id) => {
		let types = {
			'1': 'Wasted',
			'2': 'Administered',
			'3': 'Created',
			'4': 'Un-Administered',
			'5': 'Adjusted Dosage',
			'6': 'Transferred'
		};
		return types[id];
	};

	_handleToggleClick = () => {
		let toggleValue = this.state.toggleValue;
		if (toggleValue === 1) {
			this.setState({ toggleValue: 2 });
		} else {
			this.setState({ toggleValue: 1 });
		}
	};

	render() {
		setTimeout(() => {
			this._createChart();
		}, 500);

		return (
			<Card className="g-drug-administration-card">
				<div className="top-row">
					<Label black larger>
						Drug Usage
					</Label>
					<Toggle
						valueChange={this._handleToggleClick}
						ref={(ref) => (this.toggle = ref)}
						option1="Vials"
						option2="Dosage"
					/>
				</div>
				<div>{this._renderFilter()}</div>
				<div className="chart-container">
					<canvas id="drug-administration-chart" />
				</div>
			</Card>
		);
	}
}

let toSimpleDate = (dateTime) => {
	return (
		(dateTime.getMonth() + 1 + '').padStart(2, 0) +
		'-' +
		dateTime
			.getDate()
			.toString()
			.padStart(2, 0) +
		'-' +
		dateTime.getFullYear()
	);
};



// WEBPACK FOOTER //
// ./src/components/drugAdministrationCard/DrugAdministrationCard.jsx